var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"splashScreen"},[_c('img',{staticClass:"kovoLogo",attrs:{"src":"/static/img/KovoLogoWhite.svg","alt":""}}),_c('MessageModal',{ref:"messageModal",attrs:{"message":_vm.appMessage.text,"type":_vm.appMessage.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }